import * as authenticationContext from './authentication-context';
const exportable = {
  authenticationContext
};
export default exportable;
